export default __webpack_public_path__ + "static/media/gallery-wip-emitter_10.7a9008f2.jpg";